import { Dialog, Layer, ThemeProvider } from '@fluentui/react';
import ReactDOM from 'react-dom';

import { theme } from '../utils/theme';

type Props = {
  title?: string;
  subText?: string;
  showCloseButton?: boolean;
  onClosed?: () => void;
  children?: React.ReactNode;
};

export default (props: Props) => {
  const div = document.createElement("div");
  document.body.appendChild(div);

  const closeModal = () => {
    props.onClosed?.();
    ReactDOM.unmountComponentAtNode(div);
    div.remove();
  };

  ReactDOM.render(
    <Layer>
      <Dialog
        hidden={false}
        onDismiss={closeModal}
        dialogContentProps={{
          title: props.title,
          subText: props.subText,
          showCloseButton: props.showCloseButton,
        }}
      >
        <ThemeProvider theme={theme}>{props.children}</ThemeProvider>
      </Dialog>
    </Layer>,
    div
  );

  return closeModal;
};
